import { useNavigate } from 'react-router-dom';
import './NotFound.scss';
interface INotFoundProps {
  title?: string;
  subTitle?: string;
}

const NotFound = (props: INotFoundProps) => {
  const { title = '404: Not Found', subTitle = 'The page you requested was not found.' } = props;
  const navigate = useNavigate();
  const onBackBtnClicked = async () => {
    navigate(-1);
  };

  const onHomeBtnClicked = async () => {
    navigate('/', { replace: true });
  };
  return (
    <div className="NotFound">
      <h1>{title}</h1>
      <p>{subTitle}</p>
      <div className="Button_Container">
        <button className="primary-cta-btn" onClick={onHomeBtnClicked}>
          Go Home
        </button>
        <button className="secondary-cta-btn" onClick={onBackBtnClicked}>
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFound;
